import ApiService from '../common/api.service'

class ProductService extends ApiService {

  consulteVoucherCode (voucherCode) {
    return this.get(`/voucher/validate`, {
      params: {
        'voucherCode': voucherCode
      }
    }).then((res) => Promise.resolve(res.data))
  }

  cancelVoucherCode (voucherCode) {
    return this.put(`/voucher/cancel`, null, {
      params: {
        'voucherCode': voucherCode
      }
    }).then((res) => Promise.resolve(res.data))
  }

}

export default ProductService



// WEBPACK FOOTER //
// ./src/app/services/voucher/voucher.service.js